import Vue from 'vue'
import Vuex from 'vuex'
import {
  getCashierActivities,
  getOPDActivitiesByHN,
  getPharmacyActivities,
  getRegistrationActivities
} from '../services/api/activityController'
import { getHospitalInfo } from '../services/api/hospitalController'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    hospitalName: '',
    patientName: '',
    hn: '',
    pid: '',
    patientGender: '',
    activities: [],
    opdActivities: [],
    registrationActivities: [],
    cashierActivities: [],
    pharmacyActivities: []
  },
  mutations: {
    setHospitalInfo (state, data) {
      state.hospitalName = data.name
    },
    setPatientInfo (state, data) {
      state.patientName = data.patientName
      state.patientGender = data.gender
      state.hn = data.hn
      state.pid = data.pid
    },
    setOPDActivities (state, data) {
      state.opdActivities = data.activities
    },
    setRegistrationActivities (state, data) {
      state.registrationActivities = data.activities
    },
    setCashierActivities (state, data) {
      state.cashierActivities = data.activities
    },
    setPharmacyActivities (state, data) {
      state.pharmacyActivities = data.activities
    },
    setActivities (state) {
      state.activities = [
        ...state.registrationActivities || [],
        ...state.opdActivities || [],
        ...state.cashierActivities || [],
        ...state.pharmacyActivities || []
      ]
    },
    cleanupActivities (state) {
      state.activities = []
      state.opdActivities = []
      state.registrationActivities = []
      state.cashierActivities = []
      state.pharmacyActivities = []
      state.patientName = ''
      state.hn = null
      state.pid = null
      state.visitId = null
    }

  },
  actions: {
    async getActivitiesAction (context) {
      if (context.state.hospitalName === '') {
        try {
          await context.dispatch('getHospitalInfoAction')
        } catch (err) {
          console.log(err)
          return err
        }
      }
      // OPD
      const opdPromise = getOPDActivitiesByHN().then((data) => {
        context.commit('setOPDActivities', data)
        return data
      }).catch((err) => {
        console.log(err)
        if ([401, 403, 404, 500, 502].indexOf(err.status) > -1) {
          return Promise.resolve(null)
        }
        return Promise.reject(err)
      })
      // Registration
      const registrationPromise = getRegistrationActivities().then((data) => {
        context.commit('setRegistrationActivities', data)
        return data
      }).catch((err) => {
        console.log(err)
        if ([401, 403, 404, 500, 502].indexOf(err.status) > -1) {
          return Promise.resolve(null)
        }
        return Promise.reject(err)
      })
      // Pharmacy
      const pharmacyPromise = getPharmacyActivities().then((data) => {
        context.commit('setPharmacyActivities', data)
        return data
      }).catch((err) => {
        console.log(err)
        if ([401, 403, 404, 500, 502].indexOf(err.status) > -1) {
          return Promise.resolve(null)
        }
        return Promise.reject(err)
      })
      // Cashier
      const cashierPromise = getCashierActivities().then((data) => {
        context.commit('setCashierActivities', data)
        return data
      }).catch((err) => {
        console.log(err)
        if ([401, 403, 404, 500, 502].indexOf(err.status) > -1) {
          return Promise.resolve(null)
        }
        return Promise.reject(err)
      })
      const waitPromises = [opdPromise, registrationPromise, pharmacyPromise, cashierPromise]
      // const waitPromises = [pharmacyPromise, cashierPromise]
      return Promise.all(waitPromises).then((allData) => {
        // If there is no activities because of 401, 403, 404, 500, 502, datum is null
        const patientData = allData.find(a => a !== null && a.patientName)
        if (patientData) {
          context.commit('setPatientInfo', patientData)
        } else {
          return Promise.reject(new Error('No patient data'))
        }
        context.commit('setActivities')
        return allData
      }).catch((err) => {
        console.log('err: ', err)
        // TODO: redirect to scan page
      })
    },
    getHospitalInfoAction (context) {
      return getHospitalInfo().then((data) => {
        context.commit('setHospitalInfo', data)
        return data
      })
    }
  }
})
